import React from 'react'

const IncomeReport = () => {
  return (
    <div>IncomeReport</div>
  )
}

export default IncomeReport